<template>
  <div class="addDevice">
    <v-header :go-back="true" :mine='true'></v-header>
    <div class="title">{{$t('addDevice.scanQRC')}}</div>
    <div class="functionBox">
      <div class="makePhoto" v-if="goPhoto">
        <img src="../../image/makephoto.png" alt @click="makePhoto">
        <div class="hint">{{$t('addDevice.makePhotoSign')}}</div>
        <input type="file" ref="upload" accept="image/*"  @change="getPhoto" v-show="false">
      </div>
      <div class="cropPhoto" v-else>
        <vueCropper
          ref="cropper"
          :img="imgCropper.img"
          :autoCrop="imgCropper.autoCrop"
          :autoCropWidth="imgCropper.autoCropWidth"
          :autoCropHeight="imgCropper.autoCropHeight"
          :fixedBox="imgCropper.fixedBox"
        ></vueCropper>
        <div class="conntScan" v-if="conntScan">
          {{$t('addDevice.ifConntRecog')}}
          <span @click="toInputId"> {{$t('addDevice.inputQRC')}}</span>
        </div>
        <div class="btnbox">
          <div>
            <button
              type="button"
               v-loading.fullscreen.lock="fullscreenLoading"
              @click="finish('base64')"
            >{{$t('addDevice.recogQRC')}}</button>
          </div>
          <div>
            <button type="button" @click="remake">{{$t('addDevice.reMake')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- <button type="button" @click="bindDevices(code)" style="color:red;">{{$t('addDevice.bingDev')}}</button> -->
    <div class="modal" v-if="isSuccess">
      <h3>{{$t('addDevice.chackYourId')}}
        <div>{{deviceId}}</div>
        <!-- http://manager.dognessnetwork.com/device/qr?id=EAA18080200018 -->
      </h3>
      <div class="btnbox">
        <div>
          <button type="button" @click="bindDevices(deviceId)">{{$t('addDevice.bingDev')}}</button>
        </div>
        <div>
          <button type="button" @click="cancelBind">{{$t('addDevice.cancel')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from "../../components/header";
import { VueCropper } from "vue-cropper";
import { bindDevice } from "../../deviceApi/index.js";
import { getLoginUser } from "../../api/index.js";
import Qs from "qs";
export default {
  name: "addDevice",
  data() {
    return {
      code:'EAA19031400012',
      picValue: "",
      conntScan: false, //无法解析时提示语是否显示，默认为false
      goPhoto: true,
      deviceId: "",
      isSuccess: false,
      fullscreenLoading: false,
      imgCropper: {
        img: "",
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true
      }
    };
  },
  created() {
    //检验是否登录超时
    if (sessionStorage.getItem("login") == 1) {
      getLoginUser()
        .then(res => {
          if (res.data.header.status == 3019) {
            sessionStorage.setItem("login", "1");
            this.$message({
              type: "success",
              message: this.$t("prompt.header")
            });
            this.$router.push("/login");
          }
        })
        .catch(err => {});
    }
  },
  methods: {
    makePhoto() {
      this.$refs.upload.click();
    },
    getPhoto(e) {
      // console.log("not e:",e)
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.picValue = files[0];
      //   this.imgPreview(this.picValue);
        this.goPhoto = false;
      //   console.log(this.picValue);
      this.fullscreenLoading = true;
      setTimeout(() => {
         this.imgPreview(this.picValue);
        this.fullscreenLoading = false;
      }, 2000);
    },
    imgPreview(file) {
      // console.log("file：",file)
      let self = this;
      let Orientation;
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          let result = this.result;
          let img = new Image();
          img.src = result;
          self.imgCropper.img = img.src;
          // console.log( self.imgCropper.img);
        };
      }
    },
    finish(type) {
      //裁剪后预览
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: this.$t('addDevice.recogging'),
        spinner: "el-icon-loading",
        color: "rgba(225,225,225)",
        background: "rgba(0, 0, 0, 0.8)"
      });
      setTimeout(() => {
        loading.close();
        this.$refs.cropper.getCropData(data => {
          //data===裁剪后BASE64
          qrcode.decode(data);
          qrcode.callback = function(imgMsg) {
            // alert(imgMsg);
            if (imgMsg == "error decoding QR Code") {
              //错误！没识别到二维码
              self.conntScan = true;
              self.$message({
                showClose: true,
                message: self.$t('addDevice.conntRecog'),
                type: "error",
                center: true
              });
            } else {
              //成功
              //获取已经识别连接中的设备ID
              if (imgMsg.indexOf("=EAA") != -1) {
                //若含有EAA，则为多尼斯设备==>绑定
                self.isSuccess = true;
                // self.deviceId = imgMsg.substring(imgMsg.indexOf("=") + 1);
                self.deviceId = imgMsg.slice(imgMsg.indexOf("=")+1,imgMsg.indexOf("&"));
              } else {
                if (imgMsg.indexOf("http") != -1) {
                  //若解析为连接直接跳转
                  window.location.href = imgMsg;
                  self.goPhoto = true;
                } else {
                  self.$alert(imgMsg, this.$t('addDevice.QRCcontent'), {
                    confirmButtonText: this.$t('addDevice.sure')
                  });
                }
              }
            }
          };
        });
      }, 1500);
    },
    remake() {
      //取消编辑图片
       this.goPhoto = true;
      // this.$confirm("确定要放弃正在编辑的图片吗?", "放弃编辑", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "我再看看",
      //   type: "warning"
      // })
      //   .then(() => {
         
      //   })
      //   .catch(() => {});
    },
    bindDevices(id) {
      console.log(id)
      // var str = this.input.substr(0,1);
      var str = id.substr(0,1);
      if (str == "E"){
        let params = Qs.stringify({
          code: id
        });
        bindDevice(params)
        .then(res => {
          if (res.data.header.status == 1000) {
            this.$message({
              message: this.$t('addDevice.successBind'),
              type: "success",
              center: true
            });
            this.$router.push("/");
          } else if (res.data.header.status == 80013) {
            this.$message.error(this.$t('addDevice.alreadyBinged'));
          }else if(res.data.header.status == 80002){
            this.$message.error(this.$t('addDevice.notexist'));
          }
        })
        .catch(err => {
          console.log(err)
        });
      }else{
        this.$message.error(this.$t('bindById.cannotBind'))
      }
      
    },
    cancelBind() {
      this.goPhoto = true;
      this.isSuccess = false;
    },
    toInputId() {
      this.$router.push("/bindById");
    }
  },
  components: {
    "v-header": header,
    VueCropper
  }
};
</script>
<style>

</style>
<style scoped>
.addDevice {
  height: 100%;
  position: relative;
  background: #efeff3;
}

.title {
  text-align: center;
  font-size: 0.8rem;
  color: #828282;
  margin-top: 1rem;
}

.makePhoto {
  text-align: center;
}

.hint {
  font-size: 0.8rem;
  width: 80%;
  color: #828282;
  margin: 0 auto;
  margin-top: 20px;
}

.makePhoto img {
  width: 8rem;
  margin-top: 30%;
}

.cropPhoto {
  width: 100%;
  height: 400px;
}

.btnbox {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-top: 30px;
}

.btnbox div {
  flex: 1;
  text-align: center;
}

.btnbox button {
  border: 0;
  width: 80%;
  height: 40px;
  color: #fff;
  background-color: #71b8ff;
  outline: none;
  font-size: 0.8rem;
  border-radius: 20px;
}

.modal {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 100;
}

.modal h3 {
  color: #fff;
  text-align: center;
  margin-top: 80px;
}

.modal h3 div {
  font-size: 1.2rem;
  margin-top: 10px;
}

.conntScan {
  text-align: center;
  margin-top: 10px;
  font-size: 0.8rem;
  color: #828282;
}

.conntScan span {
  color: #0f589b;
  margin-left: 5px;
}

/**************************/

.content {
  margin: auto;
  max-width: 1200px;
  margin-bottom: 100px;
}

.test-button {
  display: flex;
  flex-wrap: wrap;
}

.btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #c0ccda;
  color: #1f2d3d;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 20px 10px 0px 0px;
  padding: 9px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #50bfff;
  border-color: #50bfff;
  transition: all 0.2s ease;
  text-decoration: none;
  user-select: none;
}

.des {
  line-height: 30px;
}

code.language-html {
  padding: 10px 20px;
  margin: 10px 0px;
  display: block;
  background-color: #333;
  color: #fff;
  overflow-x: auto;
  font-family: Consolas, Monaco, Droid, Sans, Mono, Source, Code, Pro, Menlo,
    Lucida, Sans, Type, Writer, Ubuntu, Mono;
  border-radius: 5px;
  white-space: pre;
}

.show-info {
  margin-bottom: 50px;
}

.show-info h2 {
  line-height: 50px;
}

.test {
  height: 500px;
}

.model {
  position: fixed;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}

.model-show {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  text-align: center;
}

.model img {
  display: block;
  margin: auto;
  max-width: 80%;
  width: auto;
  user-select: none;
  background-position: 0px 0px, 10px 10px;
  background-size: 20px 20px;
  background-image: linear-gradient(
      45deg,
      #eee 25%,
      transparent 25%,
      transparent 75%,
      #eee 75%,
      #eee 100%
    ),
    linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
}
.c-item {
  display: block;
  padding: 10px 0;
  user-select: none;
}
.pre {
  display: flex;
}
.pre-item {
  padding-right: 20px;
}
@keyframes slide {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}
@media screen and (max-width: 1000px) {
  .content {
    max-width: 90%;
    margin: auto;
  }
  .test {
    height: 400px;
  }
}
</style>


// WEBPACK FOOTER //
// src/m_page/home/addDevice.vue